import PrivacyRepository from './privacyRepository'
import BannersRepository from './bannersRepository'
import CategoriesRespository from './categoriesRepository'
import AlgoliaRepository from './algoliaRepository'
import ProfilesRepository from './profilesRepository'
import LocationRepository from './locationRepository'
import brazeRepository from './brazeRepository'

const repositories = {
    privacy: PrivacyRepository,
    categories: CategoriesRespository,
    banners: BannersRepository,
    profiles: ProfilesRepository,
    algolia: AlgoliaRepository,
    location: LocationRepository,
    braze: brazeRepository
}

export const RepositoryFactory = {
    get: name => repositories[name],
}